export enum PriceRoundingBehavior {
  Floor = "Floor",
  Ceil = "Ceil",
}
